import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCirclePlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M13.77 20.31A8.5 8.5 0 1 1 20.31 13.77" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12.2 10.8 15 16 9.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.25 16.5v5.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 19.25h5.5" })
	]
});
const ForwardRef = forwardRef(SvgCheckCirclePlus);
export default ForwardRef;
